<template>
  <div>
    <Head title="Sector" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      Sectors
    </h1>
    <div class="sectors-center flex justify-between mb-6">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        @reset="reset"
        :show-dropdown="false" />
      <Link class="btn-indigo" href="/sectors/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Sector</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Name
            </th>
            <th class="pb-4 pt-6 px-6">
              Description
            </th>
            <th class="pb-4 pt-6 px-4">
              Created
            </th>
            <th class="pb-4 pt-6 px-4" colspan="2">
              Last Updated
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="sector in sectors.data"
            :key="sector.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/sectors/${sector.id}/edit`"
                tabindex="-1">
                {{ sector.name }}
              </Link>
            </td>
            <td class="whitespace-pre-line border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/sectors/${sector.id}/edit`"
                tabindex="-1">
                {{ sector.desc }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/sectors/${sector.id}/edit`"
                tabindex="-1">
                {{ sector.created_at }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/sectors/${sector.id}/edit`"
                tabindex="-1">
                {{ sector.updated_at }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="`/sectors/${sector.id}/edit`"
                tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="sectors.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="5">
              No Sectors found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="sectors.links" />
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        filters: Object,
        sectors: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                router.get('/sectors', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
